import { compose, withHandlers } from 'recompose';

import { withModals } from 'ha/modules/ModalsLogic';
import { MobileFiltersModalName } from 'ha/constants/Filters';
import OtherFilterButton from './OtherFilterButton';

const enhance = compose(
  withModals({ name: MobileFiltersModalName }),
  withHandlers({
    onClick: props => () => {
      if (!props.isModalOpen) {
        props.handleOpen();
      }
    },
  }),
);

export default enhance(OtherFilterButton);
